export default "./edit.svg"